import { render, staticRenderFns } from "./TemplatePanel.vue?vue&type=template&id=169cdea6&scoped=true&"
import script from "./TemplatePanel.vue?vue&type=script&lang=js&"
export * from "./TemplatePanel.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePanel.vue?vue&type=style&index=0&id=169cdea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169cdea6",
  null
  
)

export default component.exports